import React from 'react';
import { cx } from './utils';

export default function Alert({ tone = 'info', title, children, className }) {
  return (
    <div className={cx('alert', `alert--${tone}`, className)} role={tone === 'danger' ? 'alert' : 'status'}>
      {title && <div className="alert__title">{title}</div>}
      <div className="alert__body">{children}</div>
    </div>
  );
}
